/* Need to disable import/first rule for polyfilling fetch... */
/* eslint-disable import/first */
require('es6-promise').polyfill(); // eslint-disable-line
import fetch from 'isomorphic-fetch';
import {
  FETCH_GDOC_DATA,
  // FETCH_GDOC_DATA_ERROR,
  FETCH_GDOC_DATA_SUCCESS,
} from '../config/types';
import actionTrigger from '../actions';
import loadData from './loadData';

export default function fetchData(
  key,
  type = 'all',
  sortable = true,
  showFootnotes = false,
  showNotes = false,
  tableIndex = 0
) {
  return (dispatch) => {
    // Alert data is fetching
    dispatch(actionTrigger(FETCH_GDOC_DATA));

    return fetch(`https://gdocs.kff.alley.ws/spreadsheets/${key}`)
      .then((response) => response.json())
      .then((data) => {
        dispatch(actionTrigger(FETCH_GDOC_DATA_SUCCESS, data));
        // Now lets load the data!
        dispatch(loadData(
          data,
          type,
          sortable,
          showFootnotes,
          showNotes,
          tableIndex
        ));
      });
      // .catch((error) =>
      //   dispatch(actionTrigger(FETCH_GDOC_DATA_ERROR, { error }))
      // );
  };
}



// WEBPACK FOOTER //
// ./app/actions/fetchData.js